import { onCLS, onFID, onFCP, onLCP, onTTFB, Metric } from 'web-vitals';

/**
 * Web Vitals Monitoring
 *
 * Métricas Core Web Vitals (usadas pelo Google para ranking):
 * - LCP (Largest Contentful Paint): tempo até maior elemento carregar
 * - FID (First Input Delay): responsividade na primeira interação
 * - CLS (Cumulative Layout Shift): estabilidade visual
 *
 * Métricas adicionais:
 * - FCP (First Contentful Paint): tempo até primeiro conteúdo
 * - TTFB (Time to First Byte): tempo de resposta do servidor
 *
 * SÓ RODA EM PRODUÇÃO - não afeta desenvolvimento
 */

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  // Só executa em produção
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Core Web Vitals (Google usa para SEO)
    onCLS(onPerfEntry);  // Cumulative Layout Shift
    onFID(onPerfEntry);  // First Input Delay
    onLCP(onPerfEntry);  // Largest Contentful Paint

    // Métricas adicionais
    onFCP(onPerfEntry);  // First Contentful Paint
    onTTFB(onPerfEntry); // Time to First Byte
  }
};

/**
 * Handler para exibir métricas no console (desenvolvimento/debug)
 *
 * Thresholds (valores bons segundo Google):
 * - LCP: < 2.5s (bom), 2.5-4s (precisa melhorar), > 4s (ruim)
 * - FID: < 100ms (bom), 100-300ms (precisa melhorar), > 300ms (ruim)
 * - CLS: < 0.1 (bom), 0.1-0.25 (precisa melhorar), > 0.25 (ruim)
 */
export const logWebVitals = (metric: Metric) => {
  const { name, value, rating, delta } = metric;

  // Emoji baseado no rating
  const emoji = rating === 'good' ? '✅' : rating === 'needs-improvement' ? '⚠️' : '❌';

  console.log(
    `${emoji} [Web Vitals] ${name}:`,
    `${Math.round(value)}${name === 'CLS' ? '' : 'ms'}`,
    `(${rating})`,
    `Δ${Math.round(delta)}${name === 'CLS' ? '' : 'ms'}`
  );
};

/**
 * Handler para enviar métricas para analytics
 *
 * Exemplo de integração com Google Analytics:
 *
 * export const sendToAnalytics = (metric: Metric) => {
 *   const { name, value, id } = metric;
 *
 *   // Google Analytics 4
 *   if (typeof gtag !== 'undefined') {
 *     gtag('event', name, {
 *       value: Math.round(value),
 *       metric_id: id,
 *       metric_value: value,
 *       metric_delta: metric.delta,
 *       metric_rating: metric.rating,
 *     });
 *   }
 * };
 */
export const sendToAnalytics = (metric: Metric) => {
  // TODO: Integrar com seu serviço de analytics
  // Por enquanto, só loga no console
  logWebVitals(metric);
};

export default reportWebVitals;
